import { styles } from 'consts';
import styled from 'styled-components';

const { mainBg, greenPrimary, bluePrimary, paymentColor, fontMBank } = styles;

export const PaymentDetailsWrapper = styled.div`
  display: flex;
  margin: 1.4375rem 0;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const PaymentDetailsInput = styled.div`
  width: 9rem;
  height: 3rem;
  box-shadow: 0 8px 12px -8px rgba(0, 0, 0, 0.34);
  border-radius: 0.1875rem;
  background-color: ${mainBg};
  position: relative;
  &:focus {
    outline: none;
  }

  .blik__textfield {
    width: 6.5rem;
    padding: 0.575rem 0 0.125rem 0.375rem;
    height: 1.5rem;
    font-family: ${fontMBank};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    font-variant-numeric: tabular-nums;
    line-height: 1.09;
    letter-spacing: 0.25rem;
    color: ${paymentColor};
    font-size: 1.125rem;
    text-align: left;
    background: transparent;
    outline: none;
    margin: 0.5rem 1rem;
    position: absolute;
  }

  .blik__textfield.blik__textfield-center {
    text-align: center;
    padding-left: 0.3rem;
  }

  input {
    caret-color: ${paymentColor};
    position: absolute;
    left: 0;
    width: 6.5rem;
    padding: 0.375rem 0 0.125rem 0.375rem;
    height: 1.5rem;
    font-family: ${fontMBank};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    font-variant-numeric: tabular-nums;
    line-height: 1.09;
    letter-spacing: 0.25rem;
    text-align: left;
    color: transparent;
    font-size: 1.125rem;
    border: none;
    border-bottom: 0.0625rem solid rgba(156, 156, 155, 0.5);
    background: transparent;
    outline: none;
    margin: 0.5rem 1rem;
    transition: border-color 200ms ease-in-out;
    &:focus {
      border-color: ${bluePrimary};
    }
    &.success {
      border-color: ${greenPrimary};
    }
  }
`;
